import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RentalSalesFinderFilter } from '../models/rental-sales-finder-filter.model';

/**
 * Shares the Rentals/Sales Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FboFinderFiltersService} (a root-provided BehaviorSubject).
 */
@Injectable({
  providedIn: 'root'
})
export class RentalSalesFinderFiltersService {

  private rentalSalesFinderFilterSubject$ = new BehaviorSubject<RentalSalesFinderFilter>(new RentalSalesFinderFilter());
  rentalSalesFinderFilter = this.rentalSalesFinderFilterSubject$.asObservable();

  constructor() { }

  updateRentalSalesFinderFilters(rentalSalesFinderFilter: RentalSalesFinderFilter) {
    this.rentalSalesFinderFilterSubject$.next(rentalSalesFinderFilter);
  }
}
